module.exports = __webpack_public_path__ + "0d6a7c91c9f6cb9e43ff27674c11c72c.png";